/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';

import Rating from '../../../containers/RightSidebar/Rating';

import styles from './ReleaseNotes.module.scss';

const RATING_ENABLED = true;

export default function ReleaseNotes({
  releaseDate,
}) {
  const releaseFeedback = localStorage.getItem('mb-user-rating');
  // NOTE: Change description every time you update release notes
  const releaseDescription = 'Live Streaming';

  return (
    <div className={styles.releaseNotes}>
      <div className={styles.main}>
        <div className={styles.paragraph}>
          <div className={styles.paragraphBody}>
            <span className={styles.image} />
            <h3>Live Streaming</h3>
            <p>
              {'We have continued to improve our horse racing and streaming features, with all UK and Irish races available to stream for free for all Matchbook customers.'}
            </p>
          </div>
        </div>
      </div>
      {RATING_ENABLED && releaseFeedback !== releaseDate && (
        <Rating
          totalStars={5}
          releaseDate={releaseDate}
          releaseDescription={releaseDescription}
        />
      )}
    </div>
  );
}

ReleaseNotes.propTypes = {
  releaseDate: PropTypes.string.isRequired
};
